export const adaptSolutionsSectionToMobile = () => {
    if (window.innerWidth <= 767) {
        let solutionsSectionItems = document.getElementsByClassName('solutions-section__item');
        for (let item of solutionsSectionItems) {
            let solutionsItemTitle = item.getElementsByClassName('solutions-section__title')[0];
            let solutionsItemTitleHeight = solutionsItemTitle.getBoundingClientRect().height;
            solutionsItemTitle.style.top = '-' + (solutionsItemTitleHeight + 20) + 'px';
        }

        let solutions = document.getElementsByClassName('solutions__content');
        for (let solution of solutions) {
            let solutionTitle = solution.getElementsByClassName('solutions-section__title')[0];
            let solutionTitleHeight = solutionTitle.getBoundingClientRect().height;
            solutionTitle.style.top = '-' + (solutionTitleHeight + 20) + 'px';
        }
    }
}
